var table_viewer_default = {
  "viewMode": "rp9Pg",
  "editMode": "_-3CV6",
  "container": "pGx5h",
  "cell": "-FVe0"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
